<template>
  <div>
    <b>Update Station simulation</b>
    <v-text-field label="Station ID" v-model="stationPayload.id"></v-text-field>
<!--    <v-text-field label="Station Name" v-model="stationPayload.name"></v-text-field>-->
    <div class="d-flex flex-wrap" style="gap: 8px">
      <v-select
          v-for="(item, i) in stationSlot"
          :key="i"
          style="min-width: 40%; max-width: 40%"
          :label="'Slot ' + (i + 1) + ' status'"
          :items="slotStatuses"
          menu-props="offsetY"
          :value="item"
          @change="changeSlotStatus(i, $event)"
      ></v-select>
    </div>
<!--    <v-text-field label="Station Latitude" v-model="stationPayload.lat"></v-text-field>-->
<!--    <v-text-field label="Station Longitude" v-model="stationPayload.lng"></v-text-field>-->

    <div class="d-flex" style="gap: 12px">
      <v-btn color="primary" @click="onSave">Update</v-btn>
      <v-btn color="primary" @click="onSync">Sync with status</v-btn>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "UpdateStation",
  data () {
    return {
      stationPayload: {
        id: 1
      },
      stationSlot: [
        'CLOSE',
        'CLOSE',
        'CLOSE',
        'CLOSE',
        'CLOSE',
        'CLOSE',
        'CLOSE',
        'CLOSE',
        'CLOSE',
        'CLOSE',
      ],
      slotStatuses: [
          'OPEN', 'CLOSE'
      ]
    }
  },
  methods: {
    onSave () {
      axios.post('https://windee-cms.ksta.co/api/update-status-station_slot/'+this.stationPayload.id, {
        ...this.stationPayload,
        stationSlot: this.stationSlot
      })
    },
    async onSync () {
      let res = await axios.post('https://windee-cms.ksta.co/api/update-status-sync', {
        stationId: this.stationPayload.id
      })
      while (res.data.return.slot.length > 10) {
        res.data.return.slot.pop()
      }
      this.stationSlot = res.data.return.slot
    },
    changeSlotStatus (index, val) {
      this.stationSlot[index] = val
    }
  }
}
</script>

<style scoped>

</style>